module.exports = __webpack_public_path__ + "img/pc.fc20baab.png";